<template>
  <div>
    <h2 class="text-1xl font-bold text-gray-700">
      Guia de remision segun venta
    </h2>
    <MainSalesReferralGuide />
  </div>
</template>

<script>
import MainSalesReferralGuide from "@/components/ReferralGuide/MainSalesReferralGuide.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "SalesReferralGuide",
  components: {
    MainSalesReferralGuide,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
